import { render, staticRenderFns } from "./radish-simple-add.vue?vue&type=template&id=04c26f6e"
import script from "./radish-simple-add.vue?vue&type=script&lang=js"
export * from "./radish-simple-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports